import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../utils/rtk-query';

export type CompanySettings = {
  includeCompanyNameOnInvoice?: boolean;
  allowDataReset: boolean;
};

export const loadManagementServiceApi = createApi({
  reducerPath: 'loadManagementServiceApi',
  baseQuery: axiosBaseQuery({
    baseUrl: config.loadManagementServiceUrl,
  }),
  endpoints: (builder) => ({
    getCompanyInfo: builder.query<boolean, string>({
      query: (companyCRM) => ({
        url: `admin/company/companyinfo/${companyCRM}`,
        method: 'GET',
      }),
    }),
    getIsCompanyInternal: builder.query<boolean, string>({
      query: (companyCRM) => ({
        url: `admin/company/companyinfo/${companyCRM}/internal`,
        method: 'GET',
      }),
    }),
    getCompanySettings: builder.query<CompanySettings, string>({
      query: (companyCRM) => ({
        url: `admin/company/${companyCRM}/settings`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetCompanyInfoQuery, useGetIsCompanyInternalQuery, useGetCompanySettingsQuery } =
  loadManagementServiceApi;
